import { useEffect } from 'react';
import { create } from 'zustand';

type PageTitleState = {
  title: string;
  setTitle: (title: string) => void;
};

// Holds the title shown in the global app-shell header. Pages/layouts set it via
// useSetPageTitle; the shell header reads it. Empty string means "no title".
export const usePageTitle = create<PageTitleState>((set) => ({
  title: '',
  setTitle: (title) => set({ title }),
}));

// Sets the app-shell header title for the lifetime of the calling component and
// clears it on unmount, so navigating to a page that sets no title shows none.
export function useSetPageTitle(title: string) {
  const setTitle = usePageTitle((state) => state.setTitle);

  useEffect(() => {
    setTitle(title ?? '');
    return () => setTitle('');
  }, [title, setTitle]);
}
